import { Box, InputAdornment, TextField, TextFieldProps, Typography } from '@mui/material';
import styles from './BaseInput.module.scss';
import classNames from 'classnames/bind';

type BaseInputProps = TextFieldProps & {
  label?: string;
  classLabel?: string;
  iconStart?: React.ReactNode;
  iconEnd?: React.ReactNode;
  customStyle?: object;
};

const cx = classNames.bind(styles);

const BaseInput = (props: BaseInputProps) => {
  const { label, classLabel = '', iconStart, iconEnd, customStyle, ...restProps } = props;

  return (
    <Box className={cx('textfield-container')}>
      {label && <Typography className={cx(`!block !mb-1.5 ${classLabel}`)}>{label}</Typography>}
      <TextField
        {...restProps}
        InputProps={{
          startAdornment: iconStart && <InputAdornment position='start'>{iconStart}</InputAdornment>,
          endAdornment: iconEnd && <InputAdornment position='end'>{iconEnd}</InputAdornment>,
          style: customStyle,
        }}
      ></TextField>
    </Box>
  );
};

export default BaseInput;
